/**
 * Map Bounds Constants
 * Defines the fixed size limits for the map editor canvas
 */

// Maximum map size constraints (2,000 x 2,000 pixels)
export const MAX_MAP_WIDTH = 2000
export const MAX_MAP_HEIGHT = 2000
